import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Facture, Socifact, Devise, Facturedetail } from 'src/app/entity/Facture';

import { Prospect } from 'src/app/entity/Prospect';
import { ClientService } from 'src/app/service/client.service';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Contact } from 'src/app/entity/Contact';
import { AppSettings } from 'src/app/service/app.setting';
 
import { SelectprodListComponent } from '../selectprod-list/selectprod-list.component';
 
import { Router } from '@angular/router';
import { Pjoint } from 'src/app/entity/Pjoint';
import { FactureService } from 'src/app/service/facture.service';
import saveAs from 'save-as'
import { ContactService } from 'src/app/service/contact.service';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { MailsService } from 'src/app/service/mails.service';
import { MessageService } from 'primeng';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-invoice',
  templateUrl: './edit-invoice.component.html',

})
export class EditInvoiceComponent implements OnInit {

  invoiceForm: FormGroup;
  editFacturDetails: boolean;
  matAutocomplete = new FormControl();
  customers: Observable<Prospect[]>;
  contacts: Observable<Contact[]>;
  socifacts: Observable<Socifact[]>;
  devises = [];
  selectedInvoice: Facture;
  montantTva: number;
  montantTimbre: number;
  totalTTC: number;
  printable: boolean = true;
  isSignature = true;
  isAnglais = false;
  uploadedFiles: any[];
  ismail: boolean;
  displayTTC: boolean;
  displayPerso: boolean;

  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;
  dataSource: MatTableDataSource<Facturedetail>;
  displayedColumns: string[] = ['delete', 'designation', 'prixunit', 'quantite', 'remise', 'stotal'];

  calcTTC: number;
  calcHT: number;
  calcTVA: number;
  textc1: string = '';
  textc2: string = '';
  textc3: string = '';
  @Output() valueChange = new EventEmitter();



  constructor(private factureSerivice: FactureService, private fb: FormBuilder,private contactService:ContactService,private factureService:FactureService,private mailsService:MailsService
    , private clientService: ClientService
    , public dialog: MatDialog
    , private messageService: MessageService, private router: Router) { }


  ngOnInit() {
    this.initForm();
    this.initSociDevise();

    this.onChanges();

  }
  exportExcel(){
    
  }
  initForm() {
    this.invoiceForm = this.fb.group({
      billingCompany: ['', [Validators.required]],
      contactSelect: ['', [Validators.required]],
      tel: ['', [Validators.required]],
      mail: ['', [Validators.required]],
      dateInvoice: ['', [Validators.required]],
      sentDate: '',
      company: ['', [Validators.required]],
      currency: ['', [Validators.required]],
      tva: '',
      timbre: '',
      finance: '',
      annuler: '',
      observation: ''
    })
  }

  changeMode(mode: string) {


    if ('cash' === mode)
      this.selectedInvoice.timbre = true;
      else
      this.selectedInvoice.timbre = false;

      if ('terme' !== mode)
      this.selectedInvoice.dateEcheance = null;

    this.saveInvoice()
  }


  initSociDevise() {
    this.socifacts = this.factureSerivice.getAllSociFact();
    AppSettings.DEVISES.forEach(element => {
      this.devises.push(element.value);
    });

  }

  getAllDetail() {
     this.factureSerivice.getAllDetailFacture(this.selectedInvoice.idfacture).subscribe(result => {
      this.dataSource = new MatTableDataSource(result);

    });
  }
  selectInvoice(facture: Facture) {

    if (facture && facture.idfacture) {


      this.selectedInvoice = facture;
      this.matAutocomplete.setValue(this.selectedInvoice.prospectprospectId.raisonSocial);
      this.contacts = this.contactService.findContactsByProspect(facture.prospectprospectId.prospectId);
      this.invoiceForm.get('billingCompany').setValue(facture.prospectprospectId);
      this.selectedInvoice.datefacture = new Date(this.selectedInvoice.datefacture);
      this.invoiceForm.enable();
      if (this.selectedInvoice.aclasser)
        this.invoiceForm.disable();

      if (this.selectedInvoice.dateenvoicontrat)
        this.selectedInvoice.dateenvoicontrat = new Date(this.selectedInvoice.dateenvoicontrat);
      else
        this.selectedInvoice.dateenvoicontrat = null;
 

        if (this.selectedInvoice.dateEcheance)
        this.selectedInvoice.dateEcheance = new Date(this.selectedInvoice.dateEcheance);
        else
        this.selectedInvoice.dateEcheance = null;


      if (this.selectedInvoice.numeroFiche && this.selectedInvoice.numeroFiche.length > 1) {
        this.invoiceForm.get('finance').disable();
      }
      else {
        this.invoiceForm.get('finance').enable();
      }
      this.getAllDetail();
      this.tax();
    }
  }

  deselect() {
    this.selectedInvoice = null;
  }
  changeCBC(prospectId: Prospect) {


    this.selectedInvoice.prospectprospectId = prospectId;
    this.contacts = this.contactService.findContactsByProspect(this.selectedInvoice.prospectprospectId.prospectId);
    this.contactService.findContactsByProspect(this.selectedInvoice.prospectprospectId.prospectId).subscribe(result => {
      if (result) {
        this.selectedInvoice.contactcontactId = result[0];
      }
    });
  }
  tax() {
    this.totalTTC = this.selectedInvoice.montantttc;
    this.montantTva = 0;
    this.montantTimbre = 0;

    const tva = this.selectedInvoice.tva;
    const timbre = this.selectedInvoice.timbre;
    if (tva) {
      this.montantTva = this.selectedInvoice.montantotal * 0.10;
    }
    if (timbre) {

      this.montantTimbre = this.totalTTC * 0.01;

    }

  }
  printInvoice() {
    this.printFacture(this.selectedInvoice);
  }
  printInvoiceP() {
    this.printPersonaliser(this.selectedInvoice);
  }
  exportWord() {

 

  }

  saveInvoice() {
    if (!this.invoiceForm.invalid) {
       if (this.selectedInvoice.dateEcheance) {
      this.selectedInvoice.dateEcheance.setHours(10);
      }
      this.selectedInvoice.datefacture.setHours(10);
      if (this.selectedInvoice.dateenvoicontrat) {
        this.selectedInvoice.dateenvoicontrat.setHours(10);

      }
      if (this.selectedInvoice.prospectprospectId.prospectId != this.selectedInvoice.contactcontactId.prospectId.prospectId) {
        window.alert("Veuillez modifier le contact");
      }
      else if (this.editFacturDetails) {
        window.alert("Veuillez dabord sauvgarder la liste des produits");
      }
      else if (this.selectedInvoice.annuler && !this.selectedInvoice.observation) {
        window.alert("Veuillez dabord Spécifier la raison d'annulation");
      }
      else {
        this.factureSerivice.save(this.selectedInvoice).subscribe(result => {


          this.showMessageSuccess("Success", JSON.parse(JSON.stringify(result))._body);
          this.getInvoice();

          // this.printFacture(this.selectedInvoice);
        });

      }
    }
  }
  removeDetail(factureDetail: Facturedetail) {
    if (window.confirm("Are you sure")) {
      this.factureSerivice.removeDetail(factureDetail).subscribe(result => {
        this.getAllDetail();
        this.getInvoice();
      })
    }
  }
  saveList() {

    this.factureSerivice.saveAllDetailFacture(this.selectedInvoice.idfacture, this.dataSource.data).subscribe(result => {
      this.editFacturDetails = false;
      this.getInvoice();

    });
  }
  cancelList() {
    if (window.confirm("Are you sure")) {
      this.editFacturDetails = false;
      this.getAllDetail();
    }
  }
  getInvoice() {
    this.factureSerivice.get(this.selectedInvoice.idfacture).subscribe(result => {
      this.selectedInvoice = result;
      this.selectedInvoice.datefacture = new Date(this.selectedInvoice.datefacture);
      if (this.selectedInvoice.dateenvoicontrat)
        this.selectedInvoice.dateenvoicontrat = new Date(this.selectedInvoice.dateenvoicontrat);


//console.log('invoice Due date'+this.selectedInvoice.dateEcheance);


        if (this.selectedInvoice.dateEcheance)
        this.selectedInvoice.dateEcheance = new Date(this.selectedInvoice.dateEcheance);


      this.invoiceForm.markAsUntouched();
      this.invoiceForm.markAsPristine();
      this.tax();
      this.valueChange.emit(this.selectedInvoice.idfacture);
    });
  }
  changeDevise() {
    if (window.confirm('Voulez vous vraiment changer le devise !!!')) {
      this.factureSerivice.changeDevise(this.selectedInvoice.idfacture, this.selectedInvoice.devise, this.dataSource.data).subscribe(result => {
        this.showMessageSuccess("Changement devise", JSON.parse(JSON.stringify(result))._body);

        this.getAllDetail();
        this.getInvoice();

      });
    }
    else {
      this.getInvoice();
    }
  }




  valider() {
    this.validerFacture(this.selectedInvoice);
  }

  validerFacture(facture: Facture) {
    if (facture.aclasser) {
      window.alert('La factures est déja validé');
    }
    else if (facture.finance) {


      window.alert('Facture espéces \n Nb: ' + facture.observation);

    }
    else {


      if (window.confirm("Pour revoir le contrat click annuler\nNb: la validation est Irreversible ?")) {
        this.factureSerivice.validerFacture(facture).subscribe(result => {
          this.showMessageSuccess("Validé ", JSON.parse(JSON.stringify(result))._body);
          this.valueChange.emit(this.selectedInvoice.idfacture);
          //  this.router.navigateByUrl('/reporting/facturesClients');
          // this.getFactures(this.selectedClient.prospectId);
        });
      }
      else {
        this.printFacture(facture);
        if (facture.client.pjointContrat) {
          this.openFile(facture.client.pjointContrat);

        }
      }



    }

  }

  calculerHT() {
    if (this.calcTTC) {
      this.calcHT = this.calcTTC / 1.10;
      this.calcTVA = this.calcTTC - this.calcHT;
    }
    else {
      this.calcHT = 0;
      this.calcTVA = 0;
    }

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(SelectprodListComponent, {
      width: '800px',
      data: { invoice: this.selectedInvoice }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.factureSerivice.getAllDetailFacture(this.selectedInvoice.idfacture).subscribe(result => {
        this.dataSource = new MatTableDataSource(result);
        this.getInvoice();
        this.editFacturDetails = true;
      });

    });
  }



  showMessageSuccess(mesasge: string, detail) {
    this.messageService.add({ key: 'tc', severity: 'success', summary: mesasge + " avec succéss", detail: detail });
  }
  showMessageError(mesasge: string, detail) {
    this.messageService.add({ key: 'tc', severity: 'error', summary: mesasge, detail: detail });
  }



  displayFn(prospect?: Prospect): string | undefined {
    return prospect ? prospect.raisonSocial : "dfdf";
  }
  compareFn(c1: Contact, c2: Contact): boolean {
    return c1 && c2 ? c1.contactId === c2.contactId : c1 === c2;
  }
  compareSociFact(c1: Socifact, c2: Socifact): boolean {
    return c1 && c2 ? c1.sociFactId === c2.sociFactId : c1 === c2;
  }
  compareDevise(c1: Devise, c2: Devise): boolean {
    return c1 && c2 ? c1.deviseId === c2.deviseId : c1 === c2;
  }
  compareCUMSBillFn(c1: Prospect, c2: Prospect): boolean {
    return c1 && c2 ? c1.prospectId === c2.prospectId : c1 === c2;
  }
  printFacture(facture: Facture) {

    this.factureSerivice.printFacture(facture, false).subscribe(
      (res) => {

        var filename = "_" + facture.devise;

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');

        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);

      }
    );
  }
  printPersonaliser(facture: Facture) {
    //console.log(this.isAnglais);

    this.factureSerivice.printPersonaliser(facture, this.isAnglais, this.isSignature, this.textc1, this.textc2, this.textc3,false).subscribe(
      (res) => {

        var filename = "_" + facture.devise;

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');

        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);

      }
    );
  }
  fileURL: string;
  openFile(pjoint: Pjoint) {
    this.factureSerivice.pjointFile(pjoint, AppSettings.CONTRACT_FOLDER).subscribe(res => {
   //   res. = pjoint.fileName;
      //    saveAs(res, res.name);
      let fileURL = URL.createObjectURL(res);
      this.fileURL = fileURL;
      window.open(fileURL);
      //const iframe = this.hostElement.nativeElement.querySelector('iframe');
      //iframe.src = fileURL;
      //  this.uploadedFiles.push(res);
    }, (err) => { 
      //console.log('aeeeerrrree' + err); 
    });
  }

  onChanges(): void {


    this.invoiceForm.controls.billingCompany.valueChanges.subscribe(val => {
      if (val) {
        const vals = val + "";
        //if (vals.length > 1)
       //   this.customers = this.clientService.findConfByRaison(val);

      }
    });
  }
  sendFacture() {
    this.sendProforma(this.selectedInvoice, false)
  }



  sendProforma(facture: Facture, isAnglais: boolean) {


    this.uploadedFiles = []

    this.factureService.printPersonaliser(facture, isAnglais, true, "", "", "",false).subscribe(
      (res) => {
        var filename = facture.prospectprospectId.raisonSocial + '_proforma.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        res.name = filename;
        this.uploadedFiles.push(res);
        this.mailsService.findodel(6).subscribe(result => {

          this.composeMailComponent.prepareEmailModel(result, this.selectedInvoice.contactcontactId, "NAPEC", facture.prospectprospectId, this.uploadedFiles)
        })

      }
    );

  }

}
